import { render, staticRenderFns } from "./tarea-form.vue?vue&type=template&id=0b45799b&scoped=true"
import script from "./tarea-form.vue?vue&type=script&lang=js"
export * from "./tarea-form.vue?vue&type=script&lang=js"
import style0 from "./tarea-form.vue?vue&type=style&index=0&id=0b45799b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45799b",
  null
  
)

export default component.exports